import { setDateTimeLocalization } from '@racemap/utilities/functions/datetime';
import { ConfigProvider } from 'antd';
import { enableMapSet } from 'immer';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { themeConfig } from 'src/lib/theme';
import { CostCalculatorRouter } from './router/cost-calculator.router';

setDateTimeLocalization();

// makes the use of Map and Set in immer.js possible
enableMapSet();

const container = document.getElementById('root');
if (container == null) throw new Error('Could not find root element');

const root = createRoot(container);
root.render(
  <StrictMode>
    <ConfigProvider theme={themeConfig}>
      <CostCalculatorRouter />
    </ConfigProvider>
  </StrictMode>,
);
